// The sales funnel stages of a lead (backend LeadgenFormLead::STATUSES), in funnel order, with
// their chip colors. Full class names, so Tailwind finds them.
const STATUSES = [
  { value: 'new', label: 'New', chip: 'bg-primary/15 text-primary', dot: 'bg-primary' },
  { value: 'contacted', label: 'Contacted', chip: 'bg-warning/15 text-warning', dot: 'bg-warning' },
  { value: 'interested', label: 'Interested', chip: 'bg-[#FE02BB]/15 text-[#FE02BB]', dot: 'bg-[#FE02BB]' },
  { value: 'won', label: 'Won', chip: 'bg-success/15 text-success', dot: 'bg-success' },
  { value: 'lost', label: 'Lost', chip: 'bg-destructive/15 text-destructive', dot: 'bg-destructive' },
];

export const LEAD_STATUSES = STATUSES.map(status => status.value);

/** The label (translation key) and colors of a lead status. */
export function leadStatusStyle(status) {
  return STATUSES.find(item => item.value === status) ?? STATUSES[0];
}

export function leadStatusOptions(tr) {
  return STATUSES.map(status => ({ ...status, label: tr(status.label) }));
}
